export default "* Båd\n* Naturmaterialer\n* Mast\n* Sejl";